import React from 'react'

type SectionBarProps = {
  borderColor?: string
  border?: string
  className?: React.ComponentProps<'div'>['className']
  style?: React.ComponentProps<'div'>['style']
}

const SectionBar = ({
  borderColor = 'border-020',
  border = 'border-[5px]',
  className = '',
  style
}: SectionBarProps) => {
  return <div className={`${border} ${className} w-full ${borderColor}`} style={style}></div>
}

export default SectionBar
